export const ROSTER_MEMBERS_ENTITY_ID = "roster-members";

const playerDisplayName = (player) =>
  [player?.first_name, player?.last_name].filter(Boolean).join(" ") || "Jugador";

export const buildTeamFinanceDescriptor = (lineup) => {
  const teamId = lineup?.team?.id ?? lineup?.team_id;
  if (!teamId) return null;

  const name = lineup.team?.name || lineup.name || `Equipo ${teamId}`;
  const externalEntityId = `team:${teamId}`;

  return {
    externalEntityId,
    payload: {
      external_entity_id: externalEntityId,
      name,
      external_relationship_id: null,
      external_display_name: name,
      status: "active",
      apply_entry_fee: false,
    },
  };
};

export const buildPlayerFinanceDescriptor = (player) => {
  if (!player?.id) return null;

  const individualId = `roster-member:${player.id}`;
  return {
    parentEntityId: ROSTER_MEMBERS_ENTITY_ID,
    individualId,
    payload: {
      external_individual_id: individualId,
      name: playerDisplayName(player),
      user_id: player.user_id || null,
      contact_info: {
        phone_number: player.phone_number || null,
        email: player.email || null,
      },
    },
    account: {
      type: "individual",
      entityId: ROSTER_MEMBERS_ENTITY_ID,
      individualId,
      phoneNumber: player.phone_number || null,
      supportsMembership: true,
    },
  };
};

export const financeAccountDescriptor = (account) => {
  if (!account) return null;

  const isIndividual = account.type === "individual";
  return {
    type: isIndividual ? "individual" : "entity",
    entityId: isIndividual ? account.external_entity_id : account.target_id,
    individualId: isIndividual ? account.target_id : null,
    currency: account.currency_code || "",
    phoneNumber:
      account.contact_info?.phone_number ||
      account.contact_info?.phone ||
      null,
    supportsMembership: isIndividual,
  };
};

export { playerDisplayName };
